import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '../components/ui/card';
import { Heart, Users, Globe, Shield } from 'lucide-react';

export default function About() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#050505] pt-24 pb-12">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-4xl sm:text-5xl font-bold text-white mb-8" style={{ fontFamily: 'Syne, sans-serif' }}>
          {t('about.title')}
        </h1>

        <div className="space-y-8">
          {/* Mission */}
          <Card className="bg-zinc-900/50 border-white/10 p-8">
            <div className="flex items-start gap-4 mb-4">
              <Heart className="h-8 w-8 text-[#F9004D] flex-shrink-0" />
              <div>
                <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Syne, sans-serif' }}>
                  {t('about.mission.title')}
                </h2>
                <p className="text-zinc-300 leading-relaxed mb-4">
                  {t('about.mission.p1')}
                </p>
                <p className="text-zinc-300 leading-relaxed">
                  {t('about.mission.p2')}
                </p>
              </div>
            </div>
          </Card>

          {/* What We Are */}
          <Card className="bg-zinc-900/50 border-white/10 p-8">
            <div className="flex items-start gap-4 mb-4">
              <Users className="h-8 w-8 text-[#00F0FF] flex-shrink-0" />
              <div>
                <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Syne, sans-serif' }}>
                  {t('about.what.title')}
                </h2>
                <p className="text-zinc-300 leading-relaxed mb-4">
                  {t('about.what.p1')}
                </p>
                <div className="bg-zinc-800/50 p-4 rounded-lg border border-[#F9004D]/30 mb-4">
                  <p className="text-zinc-300 text-sm leading-relaxed">
                    <strong className="text-[#F9004D]">Important :</strong> {t('about.what.disclaimer')}
                  </p>
                </div>
                <p className="text-zinc-300 leading-relaxed">
                  {t('about.what.p2')}
                </p>
              </div>
            </div>
          </Card>

          {/* How It Works */}
          <Card className="bg-zinc-900/50 border-white/10 p-8">
            <div className="flex items-start gap-4 mb-4">
              <Globe className="h-8 w-8 text-[#D4AF37] flex-shrink-0" />
              <div>
                <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Syne, sans-serif' }}>
                  {t('about.how.title')}
                </h2>
                <div className="space-y-4 text-zinc-300">
                  <div>
                    <h3 className="text-white font-bold mb-2">{t('about.how.travelers.title')}</h3>
                    <ul className="list-disc list-inside space-y-1 ml-4 text-sm">
                      <li>{t('about.how.travelers.li1')}</li>
                      <li>{t('about.how.travelers.li2')}</li>
                      <li>{t('about.how.travelers.li3')}</li>
                      <li>{t('about.how.travelers.li4')}</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-white font-bold mb-2">{t('about.how.hosts.title')}</h3>
                    <ul className="list-disc list-inside space-y-1 ml-4 text-sm">
                      <li>{t('about.how.hosts.li1')}</li>
                      <li>{t('about.how.hosts.li2')}</li>
                      <li>{t('about.how.hosts.li3')}</li>
                      <li>{t('about.how.hosts.li4')}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Card>

          {/* Safety */}
          <Card className="bg-zinc-900/50 border-white/10 p-8">
            <div className="flex items-start gap-4 mb-4">
              <Shield className="h-8 w-8 text-green-500 flex-shrink-0" />
              <div>
                <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Syne, sans-serif' }}>
                  {t('about.safety.title')}
                </h2>
                <div className="space-y-3 text-zinc-300 text-sm">
                  <p>
                    <strong className="text-white">{t('about.safety.verified')}</strong>
                  </p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>{t('about.safety.li1')}</li>
                    <li>{t('about.safety.li2')}</li>
                    <li>{t('about.safety.li3')}</li>
                    <li>{t('about.safety.li4')}</li>
                  </ul>
                  <p className="mt-4">
                    {t('about.safety.law')}
                  </p>
                </div>
              </div>
            </div>
          </Card>

          {/* Contact */}
          <Card className="bg-gradient-to-r from-[#F9004D]/10 to-[#00F0FF]/10 border-[#F9004D]/30 p-8 text-center">
            <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Syne, sans-serif' }}>
              {t('about.join.title')}
            </h2>
            <p className="text-zinc-300 mb-6">
              {t('about.join.desc')}
            </p>
            <p className="text-[#00F0FF]">
              contact@guidematch-tokyo.com
            </p>
          </Card>
        </div>
      </div>
    </div>
  );
}
